module.exports = __webpack_public_path__ + "img/WESicon6.21542617.png";